import { render, staticRenderFns } from "./FinalizacaoInserir.vue?vue&type=template&id=6633da09"
import script from "./FinalizacaoInserir.vue?vue&type=script&lang=js"
export * from "./FinalizacaoInserir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports